export default __webpack_public_path__ + "static/banner-one-shape3-cc6177cc5303fe14e3ed419ad5d37474.png";